"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUserAddress = addUserAddress;
exports.default = getAddressApiWatcher;
exports.getDefaultUserAddress = getDefaultUserAddress;
exports.getUserAddress = getUserAddress;
exports.getZonesForLatLong = getZonesForLatLong;
exports.removeUserAddress = removeUserAddress;
exports.updateUserAddress = updateUserAddress;
exports.updateZone = updateZone;
exports.updateZoneInStore = updateZoneInStore;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _sagas2 = require("../../../astercore/identityService/redux/sagas");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
    Request Params
    onSuccess: success callback
    queryParam: search query parameter
*/
function* getUserAddress(requestParams) {
  const {
    showLoader = true
  } = requestParams === null || requestParams === void 0 ? void 0 : requestParams.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.GET_USER_ADDRESS_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCurruntAddress, tokenData);
    yield (0, _effects.put)(actions.GET_USER_ADDRESS_API.success(mainResponse));
    const addressUpdatedData = {
      data: {
        addresses: [...(mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data)]
      }
    };
    yield (0, _effects.call)(_sagas2.updateIdentityLocalData, addressUpdatedData);
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_USER_ADDRESS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function getIdentityAddressRequestParams(requestParams) {
  var _requestParams$data$p, _requestParams$data, _requestParams$data2;
  const requestAddressParams = {
    data: {
      requestParams: {
        userId: (_requestParams$data$p = requestParams === null || requestParams === void 0 || (_requestParams$data = requestParams.data) === null || _requestParams$data === void 0 || (_requestParams$data = _requestParams$data.params) === null || _requestParams$data === void 0 ? void 0 : _requestParams$data.userId) !== null && _requestParams$data$p !== void 0 ? _requestParams$data$p : requestParams === null || requestParams === void 0 || (_requestParams$data2 = requestParams.data) === null || _requestParams$data2 === void 0 ? void 0 : _requestParams$data2.userId,
        address: true,
        showLoader: false,
        refreshCache: true // (params to pass to get data without cache)
      }
    }
  };
  return requestAddressParams;
}
function* addUserAddress(requestParams) {
  try {
    var _requestParams$data3;
    yield (0, _effects.put)(actions.ADD_USER_ADRRESS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addUserAddress, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.ADD_USER_ADRRESS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    if ((0, _utils.isMobile)() && requestParams !== null && requestParams !== void 0 && (_requestParams$data3 = requestParams.data) !== null && _requestParams$data3 !== void 0 && (_requestParams$data3 = _requestParams$data3.params) !== null && _requestParams$data3 !== void 0 && _requestParams$data3.userId && tokenData !== null && tokenData !== void 0 && tokenData.isAccessTokenAvailable) {
      yield (0, _effects.call)(_sagas2.getCommonServiceData, getIdentityAddressRequestParams(requestParams));
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_USER_ADRRESS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* updateUserAddress(requestParams) {
  try {
    var _requestParams$data4;
    yield (0, _effects.put)(actions.UPDATE_USER_ADDRESS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateUserAddress, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_USER_ADDRESS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    if ((0, _utils.isMobile)() && requestParams !== null && requestParams !== void 0 && (_requestParams$data4 = requestParams.data) !== null && _requestParams$data4 !== void 0 && (_requestParams$data4 = _requestParams$data4.params) !== null && _requestParams$data4 !== void 0 && _requestParams$data4.userId && tokenData !== null && tokenData !== void 0 && tokenData.isAccessTokenAvailable) {
      yield (0, _effects.call)(_sagas2.getCommonServiceData, getIdentityAddressRequestParams(requestParams));
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_USER_ADDRESS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* removeUserAddress(requestParams) {
  try {
    var _requestParams$data5;
    yield (0, _effects.put)(actions.REMOVE_USER_ADDRESS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.removeUserAddress, requestParams.data.id, tokenData);
    yield (0, _effects.put)(actions.REMOVE_USER_ADDRESS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    if ((0, _utils.isMobile)() && requestParams !== null && requestParams !== void 0 && (_requestParams$data5 = requestParams.data) !== null && _requestParams$data5 !== void 0 && (_requestParams$data5 = _requestParams$data5.params) !== null && _requestParams$data5 !== void 0 && _requestParams$data5.userId && tokenData !== null && tokenData !== void 0 && tokenData.isAccessTokenAvailable) {
      yield (0, _effects.call)(_sagas2.getCommonServiceData, getIdentityAddressRequestParams(requestParams));
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REMOVE_USER_ADDRESS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getDefaultUserAddress(requestParams) {
  try {
    yield (0, _effects.put)(actions.GET_DEFAULT_USER_ADDRESS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getDefaultUserAddress, requestParams.data.address, tokenData);
    yield (0, _effects.put)(actions.GET_DEFAULT_USER_ADDRESS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DEFAULT_USER_ADDRESS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* updateZone(requestParams) {
  try {
    if (!(0, _utils.isMobile)()) yield (0, _effects.put)(actions.UPDATE_ZONE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateZone, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_ZONE_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    // commenting this failure response to update in redux as its override the previous success reponses..!!!
    // yield put(actions.UPDATE_ZONE_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* updateZoneInStore(mainResponse) {
  try {
    yield (0, _effects.put)(actions.UPDATE_ZONE_API.success(mainResponse));
    return mainResponse;
  } catch (err) {
    // commenting this failure response to update in redux as its override the previous success reponses..!!!
    // yield put(actions.UPDATE_ZONE_API.failure(err));
  }
}
function* getZonesForLatLong(requestParams) {
  try {
    if (!(0, _utils.isMobile)()) yield (0, _effects.put)(actions.GET_ZONES_FOR_LAT_LONG_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getZonesForLatLong, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_ZONES_FOR_LAT_LONG_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ZONES_FOR_LAT_LONG_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getAddressApiWatcher() {
  yield (0, _effects.takeEvery)(actions.GET_USER_ADDRESS, getUserAddress);
  yield (0, _effects.takeLatest)(actions.ADD_USER_ADRRESS, addUserAddress);
  yield (0, _effects.takeLatest)(actions.UPDATE_USER_ADDRESS, updateUserAddress);
  yield (0, _effects.takeLatest)(actions.REMOVE_USER_ADDRESS, removeUserAddress);
  yield (0, _effects.takeLatest)(actions.GET_DEFAULT_USER_ADDRESS, getDefaultUserAddress);
  yield (0, _effects.takeLatest)(actions.UPDATE_ZONE, updateZone);
  yield (0, _effects.takeLatest)(actions.UPDATE_ZONE_STATE_IN_STORE, updateZoneInStore);
  yield (0, _effects.takeLatest)(actions.GET_ZONES_FOR_LAT_LONG, getZonesForLatLong);
}